import {  useState } from 'react'
import LoadingScreen from 'components/loading-screen'
import { Question, SurveyResponse } from 'contexts/survey-context/survey.interface'
import StepCP from './steps/StepCP'
import StepHowMuch from './steps/StepHowMuch'
import StepRepresents from './steps/StepRepresents'
import StepPrize from './steps/StepPrize'

interface IProps {
  redirect: () => void
  title: string,
  id: number,
  questions: Question[];
  handleSubmit: (callback: () => Promise<void>) => void
  updatePolarisSurvey?: (select: SurveyResponse[][], id: number) => Promise<void>
}

const PostalCode = ({ questions, handleSubmit, updatePolarisSurvey, id }: IProps) => {
  const [info, setInfo] = useState({
    postalCode: '',
    neighborhoodId: null,
    state: '',
    colonia: '',
    municipality: '',
    corrienteUrbana: null
  })

  const [step, setStep] = useState(1)

  const [answers] = useState([])

  const changeStep = (count: string = '') => {
    const newStep = count === 'increment' ? step + 1 : step - 1;
    setStep(newStep);
  }

  switch (step) {
  case 1:
    return <div className="w-full"><StepCP setInfo={setInfo} info={info} changeStep={changeStep} answers={answers} question={questions[0]} /></div>;
  case 2:
    return <div className="w-full"><StepHowMuch changeStep={changeStep} answers={answers} questions={[questions[1], questions[2]]} /></div>;
  case 3:
    return <div className="w-full"><StepRepresents changeStep={changeStep} answers={answers} questions={[questions[3], questions[4], questions[5]]} handleSubmit={handleSubmit} updatePolarisSurvey={updatePolarisSurvey} id={id}/></div>;
  case 4:
    return <div className="w-full"><StepPrize /></div>;
  default:
    return <LoadingScreen />;
  }
}

export default PostalCode